import { RefreshIcon } from '@heroicons/react/solid'
import { Routes, Route, useMatch, useNavigate } from 'react-router-dom'
import { Aside, ErrorNotFound, Main, Steps } from 'src/components'
import Arn from './Arn'
import UserGroup from './UserGroup'
import User from './User'
import CreatePolicy from './CreatePolicy'
import CreateItems from './CreateItems'
import Validate from './Validate'
import Logging from '../Logging'
import CustomButton from 'src/components/Shared/UIComponents/Button'

const routes = [
  {
    path: 'arn',
    element: <Arn />,
    label: 'ARN',
  },
  {
    path: 'user_group',
    element: <UserGroup />,
    label: 'User Group',
  },
  {
    path: 'policy',
    element: <CreatePolicy />,
    label: 'Policy',
  },
  {
    path: 'user',
    element: <User />,
    label: 'User',
  },
  {
    path: 'create_items',
    element: <CreateItems />,
    label: 'Create items',
  },
  {
    path: 'validate',
    element: <Validate />,
    label: 'Validate',
  },
]

export default function Setup() {
  const navigate = useNavigate()
  const match = useMatch('/setup-saml/:step')
  const currentIndex =
    match && match.params.step
      ? routes.findIndex((item) => item.path === match.params.step)
      : -1

  return (
    <>
      <Logging />

      <Aside title="Setup" hideExtraRow={currentIndex === -1} displayHelp>
        <Steps routes={routes} currentIndex={currentIndex} disableNavigation />
      </Aside>

      <Main>
        <Routes>
          {routes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}

          <Route
            path="*"
            element={
              <ErrorNotFound>
                <CustomButton
                  label="restart setup"
                  onClick={() => navigate('./arn')}
                  icon={<RefreshIcon />}
                  iconPosition="left"
                />
              </ErrorNotFound>
            }
          />
        </Routes>
      </Main>
    </>
  )
}
